import React from 'react'
import { bindActionCreators } from 'redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropertyLabel from '../components/PropertyLabel'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { history } from '../store'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { blockOnlineSale } from '../actions/matrixs'

import RemoteActionSingleAddForm from '../forms/RemoteActionSingleAddForm'
import RemoteActionFaultAddForm from '../forms/RemoteActionFaultAddForm'
import RemoteActionFaultRepairForm from '../forms/RemoteActionFaultRepairForm'
import '../styles/LockerModal.css'

class MatrixConstructorAdmin extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      matrixModalOpen: false,
      matrixMatricula: '',
      firstIndex: 1,
      lastIndex: 70,
      currentView: 'main',
      matrixSN: '',
      lockerType: '',
      blockType: null,
      blockedLockers: [],
      waveIntro: true // one-off wave sweep right after entering the tab
    }

    this.openMatrixDialog = this.openMatrixDialog.bind(this)
    this.closeMatrixDialog = this.closeMatrixDialog.bind(this)
    this.changeView = this.changeView.bind(this)
    this.handleBlockedLocker = this.handleBlockedLocker.bind(this)
  }

  componentDidMount() {
    // Barrido de bienvenida: el tab monta el componente de cero, asi que
    // este timer corre una vez por entrada al tab. Pasados 6s (holgura para
    // el retardo por columna + 3s de animacion) se retira la clase para que
    // la onda solo pueda relanzarse con el hover del kiosko.
    this.waveIntroTimer = setTimeout(() => {
      this.setState({ waveIntro: false })
    }, 6000)
  }

  componentWillUnmount() {
    clearTimeout(this.waveIntroTimer)
  }

  goTo(Code, e) {
    history.push(`/modules/${Code}`)
  }

  openMatrixDialog(matricula, sn, type, block, e) {
    this.setState({ matrixModalOpen: true, matrixMatricula: matricula, currentView: 'main', matrixSN: sn, lockerType: type, blockType: block })
  }

  closeMatrixDialog() {
    this.setState({ matrixModalOpen: false })
  }

  handleBlockedLocker(type) {
    this.props.blockOnlineSale(this.props.machine._id, type, this.state.matrixSN, this.state.matrixMatricula)
      .then((response) => {
        this.closeMatrixDialog();
        if (this.props.refreshMatrix) {
          this.props.refreshMatrix();
        }
      })
      .catch((error) => {
        console.error('Error blocking locker:', error);
      });
  }

  getErrorCode(error) {

    switch (error) {
      case '0x00': return 'OK'
      case '0xFF': return 'INITIALIZED'
      case '0x01': return 'CONNECTED'
      case '0x02': return 'ESP32 PROCESS SUCC'
      case '0x03': return 'USER PIN ASSIGNED'
      case '0x04': return 'CONN FAULT'
      case '0x05': return 'SCAN TIMEOUT'
      case '0x06': return 'GEN ERROR 1'
      case '0x07': return 'ESP32 PROCESS UNSUCC'
      case '0x08': return 'GEN ERROR 2'
      case '0x09': return 'GEN ERROR 3'
      case '0x0A': return 'GEN ERROR 4'
      case '0x0B': return 'GEN ERROR 5'
      case '0x0C': return 'USER PIN UNASSIGNED'
      default: return error
    }
  }

  getColorClass(rssi) {
    if (rssi >= -60 && rssi !== 0) {
      return 'HIGHTOP';
    } else if (rssi < -60 && rssi >= -65) {
      return 'HIGH';
    } else if (rssi < -65 && rssi >= -70) {
      return 'HIGHLOW';
    } else if (rssi < -70 && rssi >= -75) {
      return 'MIDHIGH';
    } else if (rssi < -75 && rssi >= -80) {
      return 'MID';
    } else if (rssi < -80 && rssi >= -85) {
      return 'MIDLOW';
    } else if (rssi < -85 && rssi >= -90) {
      return 'LOWHIGH';
    } else if (rssi < -90 && rssi >= -95) {
      return 'LOW';
    } else if (rssi < -95 && rssi >= -100) {
      return 'LOWTOP';
    } else {
      return 'Null';
    }
  }

  changeView(view) {
    this.setState({ currentView: view });
  }

  infoMatrix() {
    const { role, type, category, refreshMatrix } = this.props;
    const { currentView } = this.state;

    let checkMatricula = "";
    let checkBLEName = "";
    let checkHobbit = false;
    let checkBateria = "";
    let checkRfidUid = "";
    let checkMasterUid = "";
    let checkPin = "";
    let checkPhone = "";
    let checkName = "";
    let checkEmail = "";
    let checkModule = "";
    let checkPass = "";
    let checkAdmin = "";
    let checkType = "";
    let checkPosition = "";
    let checkStatus = "";
    let checkWide = "";
    let checkMode = "";
    let checkConfigured = false;
    let checkLastNightscan = "";
    let checkRssi = 0;
    let checkGender = '';
    let checkFaultCode = '';
    let checkErrorCode = '';
    let kerongVersion = '';
    let passOpens = 0;
    let blockType = 0;
    let blockedLocker = false;

    {
      this.props.matrixs.map(matrix => {
        {
          (matrix.Serial === this.props.machine.Serial) && matrix.Locker.map((lock, index) => {

            if (index + 1 == this.state.matrixMatricula) {
              checkMatricula = lock.Matricula || checkMatricula;
              checkType = lock.Type || checkType;
              checkBLEName = lock.BLEName || checkBLEName;
              checkBateria = lock.Bateria || checkBateria;
              checkRfidUid = lock.RfidUid || checkRfidUid;
              checkMasterUid = lock.MasterUid || checkMasterUid;
              checkPin = lock.Pin || checkPin;
              checkPhone = lock.Phone || checkPhone;
              checkName = lock.Name || checkName;
              checkEmail = lock.Email || checkEmail;
              checkModule = lock.ModuleSN || checkModule;
              checkPass = lock.Pass || checkPass;
              checkAdmin = lock.PasswordCash || checkAdmin;
              checkPosition = lock.Position || checkPosition;
              checkStatus = lock.Status || checkStatus;
              checkWide = lock.wide || checkWide;
              checkMode = lock.Mode || checkMode;
              checkConfigured = lock.Configured || checkConfigured;
              checkLastNightscan = lock.LastNightScanCompleted || checkLastNightscan;
              checkRssi = lock.Rssi || checkRssi;
              checkGender = lock.Gender || checkGender;
              checkFaultCode = lock.FaultCode || checkFaultCode;
              checkErrorCode = lock.ErrorBle || checkErrorCode;
              kerongVersion = lock.KerongVersion || kerongVersion;
              passOpens = lock.PassOpens || passOpens;
              blockType = lock.BlockType || blockType;
              blockedLocker = lock.BackOfficeBlock || false;
            }
          })
        }
      })
    }

    const year = parseInt(checkLastNightscan.slice(0, 4));
    const month = parseInt(checkLastNightscan.slice(4, 6)) - 1; // month is zero-indexed
    const day = parseInt(checkLastNightscan.slice(6, 8));
    const hour = parseInt(checkLastNightscan.slice(8, 10));
    const minute = parseInt(checkLastNightscan.slice(10, 12));
    const second = parseInt(checkLastNightscan.slice(12, 14));

    const nightscanDate = new Date(year, month, day, hour, minute, second);

    nightscanDate.setHours(nightscanDate.getHours());
    const formattedDate = `${nightscanDate.getDate()}/${nightscanDate.getMonth() + 1}/${nightscanDate.getFullYear()}`;
    const formattedTime = `${nightscanDate.getHours().toString().padStart(2, '0')}:${nightscanDate.getMinutes().toString().padStart(2, '0')}`;

    const totalBattery = 6500; // Change this to the maximum battery value
    const minBattery = 4400; // Change this to the maximum battery value

    // Calculate the battery percentage
    const batteryPercentage = ((checkBateria - minBattery) / (totalBattery - minBattery)) * 100;

    // Determine the number of squares based on battery level
    let squaresCount;
    let batteryColor;

    if (batteryPercentage >= 83.3) {
      squaresCount = 5;
      batteryColor = 'green';
    } else if (batteryPercentage >= 66.7) {
      squaresCount = 4;
      batteryColor = 'green';
    } else if (batteryPercentage >= 50) {
      squaresCount = 3;
      batteryColor = 'orange';
    } else if (batteryPercentage >= 33.3) {
      squaresCount = 2;
      batteryColor = 'orange';
    } else if (batteryPercentage >= 16.7) {
      squaresCount = 1;
      batteryColor = 'red';
    } else {
      squaresCount = 0;
      batteryColor = 'red';
    }

    if (currentView === 'main') {
      const rssiLevels = ['HIGHTOP', 'HIGH', 'HIGHLOW', 'MIDHIGH', 'MID', 'MIDLOW', 'LOWHIGH', 'LOW', 'LOWTOP'];
      const currentRssi = this.getColorClass(checkRssi);
      const rssiColorMap = {
        HIGHTOP: '#ef4444', HIGH: '#f97316', HIGHLOW: '#eab308', MIDHIGH: '#84cc16',
        MID: '#22c55e', MIDLOW: '#14b8a6', LOWHIGH: '#06b6d4', LOW: '#3b82f6', LOWTOP: '#a855f7',
      };
      const rssiIdx = rssiLevels.indexOf(currentRssi);
      const rssiCount = rssiIdx === -1 ? 0 : rssiLevels.length - rssiIdx;
      const rssiAccent = rssiColorMap[currentRssi] || '#94a3b8';
      const statusColorMap = { FREE: '#16a34a', RENT: '#1d4ed8', FL: '#dc2626', Null: '#94a3b8' };
      const statusBadgeColor = statusColorMap[checkStatus] || '#64748b';
      const batteryAccent = batteryColor === 'green' ? '#16a34a' : batteryColor === 'orange' ? '#d97706' : '#dc2626';

      // Maquinas anteriores al campo no lo traen y se comportan como PIN, asi que
      // cualquier valor que no sea RFID cuenta como PIN (mismo criterio que
      // utils/machines.js getQuickAccessMode).
      const rfidMode = this.props.machine?.QuickAccessMode === 'RFID';

      return (
        <CSSTransition key="main" timeout={300} classNames="fade">
          <div className="lm-body">
            <div className="lm-cols">

              {/* Column 1: Pines + Cliente + RFID */}
              <div className="lm-col">
                <div className="lm-card lm-card-dark">
                  <div className="lm-card-header lm-card-header-dark">
                    <i className="fas fa-key"></i> Pines
                  </div>
                  <div className={`lm-card-body${rfidMode ? ' lm-locked' : ''}`}>
                    {rfidMode && (
                      <div className="lm-lock-overlay">
                        <i className="fas fa-lock"></i>
                        <span>Solo disponible en modo PIN</span>
                      </div>
                    )}
                    <div className="lm-prop"><span className="lm-key lm-key-light">Pin Cliente</span><span className="lm-val lm-val-light lm-mono">{checkPass || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key lm-key-light">Pin Universal</span><span className="lm-val lm-val-light lm-mono">{checkAdmin || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key lm-key-light">Pin Pairing</span><span className="lm-val lm-val-light lm-mono">{checkPin || '—'}</span></div>
                  </div>
                </div>
                <div className="lm-card lm-card-dark">
                  <div className="lm-card-header lm-card-header-dark">
                    <i className="fas fa-user"></i> Cliente
                  </div>
                  <div className="lm-card-body">
                    <div className="lm-prop"><span className="lm-key lm-key-light">Nombre</span><span className="lm-val lm-val-light">{checkName || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key lm-key-light">Teléfono</span><span className="lm-val lm-val-light">{checkPhone || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key lm-key-light">Email</span><span className="lm-val lm-val-light">{checkEmail || '—'}</span></div>
                  </div>
                </div>
                {/* UIDs de la taquilla. Solo se llenan en maquinas RFID: el del cliente
                    lo graba el alquiler por pulsera y el de la maestra la accion remota
                    SET_MASTER_KEY, asi que en maquinas PIN ambos salen vacios. */}
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-id-card"></i> RFID
                  </div>
                  <div className={`lm-card-body${!rfidMode ? ' lm-locked' : ''}`}>
                    {!rfidMode && (
                      <div className="lm-lock-overlay">
                        <i className="fas fa-lock"></i>
                        <span>Solo disponible en modo PULSERA RFID</span>
                      </div>
                    )}
                    <div className="lm-prop"><span className="lm-key">UID Cliente</span><span className="lm-val lm-mono">{checkRfidUid || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">UID Maestra</span><span className="lm-val lm-mono">{checkMasterUid || '—'}</span></div>
                  </div>
                </div>
              </div>

              {/* Column 2: Taquilla + Signal + Battery side by side + Nightscan + Errors */}
              <div className="lm-col">
                {/* Ocho propiedades en una sola columna hacian la tarjeta demasiado alta:
                    lm-prop-grid las reparte en dos columnas y la deja a la mitad de alto. */}
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-door-closed"></i> Taquilla
                  </div>
                  <div className="lm-card-body lm-prop-grid">
                    <div className="lm-prop"><span className="lm-key">Matrícula</span><span className="lm-val lm-mono">{checkMatricula || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">BLEName</span><span className="lm-val lm-mono">{checkBLEName || '—'}</span></div>
                    <div className="lm-prop">
                      <span className="lm-key">Estado</span>
                      <span className="lm-badge" style={{ background: statusBadgeColor }}>{checkStatus || '—'}</span>
                    </div>
                    <div className="lm-prop"><span className="lm-key">Tipo</span><span className="lm-val">{checkType || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">Género</span><span className="lm-val">{checkGender || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">Versión Kerong</span><span className="lm-val lm-mono">{kerongVersion || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">Whitelist</span><span className="lm-val">{blockType || '—'}</span></div>
                    <div className="lm-prop">
                      <span className="lm-key">Módulo</span>
                      <button className="lm-link-btn" onClick={(e) => this.goTo(checkModule, e)}>
                        <i className="fas fa-external-link-alt"></i> {checkModule || '—'}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="lm-card">
                  <div className="lm-side-by-side">
                    <div className="lm-half">
                      <div className="lm-card-header">
                        <i className="fas fa-wifi"></i> Señal BLE
                      </div>
                      <div className="lm-card-body lm-center">
                        <div className="lm-battery-pct" style={{ color: rssiAccent }}>{checkRssi} dBm</div>
                        <div className="lm-battery-bar">
                          {Array.from({ length: 9 }, (_, i) => (
                            <div
                              key={i}
                              className="lm-rssi-seg"
                              style={i < rssiCount ? { background: rssiAccent, borderColor: rssiAccent } : {}}
                            ></div>
                          ))}
                        </div>
                        <div className="lm-battery-volt">{currentRssi === 'Null' ? 'Sin señal' : currentRssi}</div>
                      </div>
                    </div>
                    <div className="lm-half-divider"></div>
                    <div className="lm-half">
                      <div className="lm-card-header">
                        <i className="fas fa-battery-full"></i> Batería
                      </div>
                      <div className="lm-card-body lm-center">
                        <div className="lm-battery-pct" style={{ color: batteryAccent }}>{batteryPercentage.toFixed(1)}%</div>
                        <div className="lm-battery-bar">
                          {Array.from({ length: 5 }, (_, i) => (
                            <div key={i} className={`lm-battery-seg${i < squaresCount ? ` filled ${batteryColor}` : ''}`}></div>
                          ))}
                        </div>
                        <div className="lm-battery-volt">{(checkBateria / 1000).toFixed(2)} V</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-moon"></i> Nightscan
                  </div>
                  <div className="lm-card-body">
                    <div className="lm-prop"><span className="lm-key">Fecha</span><span className="lm-val">{formattedDate}</span></div>
                    <div className="lm-prop"><span className="lm-key">Hora</span><span className="lm-val">{formattedTime}</span></div>
                  </div>
                </div>
                <div className="lm-card lm-card-danger">
                  <div className="lm-card-header lm-card-header-danger">
                    <i className="fas fa-exclamation-triangle"></i> Errores
                  </div>
                  <div className="lm-card-body">
                    <div className="lm-prop"><span className="lm-key">Avería</span><span className="lm-val lm-val-danger">{checkFaultCode || '—'}</span></div>
                    <div className="lm-prop"><span className="lm-key">Código BLE</span><span className="lm-val lm-val-danger lm-mono">{this.getErrorCode(checkErrorCode)}</span></div>
                  </div>
                </div>
              </div>

              {/* Column 3: Acciones Remotas + Averias y Bloqueo */}
              <div className="lm-col">
                {(role === 'ADMIN' && type === 'MASTER') && (
                  <div className="lm-card">
                    <div className="lm-card-header">
                      <i className="fas fa-hand-paper"></i> Acciones Remotas
                    </div>
                    <div className="lm-card-body">
                      <RemoteActionSingleAddForm machine={this.props.machine} lockerMatricula={this.state.matrixMatricula} lockerStatus={checkStatus} closeMatrixDialog={this.closeMatrixDialog} />
                    </div>
                  </div>
                )}
                {/* Fuera del gate de MASTER: bloquear y marcar averia no dependen del tipo
                    de licencia, igual que cuando vivian sueltos al final de la columna 2. */}
                <div className="lm-card">
                  <div className="lm-card-header">
                    <i className="fas fa-hand-paper"></i> Averias y Bloqueo
                  </div>
                  <div className="lm-card-body">
                    <div className="lm-action-row">
                      <button
                        className={`lm-action-btn ${blockedLocker ? 'lm-action-secondary' : 'lm-action-warning'}`}
                        onClick={() => this.handleBlockedLocker(blockedLocker ? false : true)}
                      >
                        <i className="fas fa-lock"></i>
                        {blockedLocker ? 'Desbloquear' : 'Bloquear'}
                      </button>
                      <button
                        className={`lm-action-btn ${checkStatus !== 'FL' ? 'lm-action-danger' : 'lm-action-success'}`}
                        onClick={() => this.changeView(checkStatus !== 'FL' ? 'faultView' : 'repairFaultView')}
                      >
                        <i className="fas fa-tools"></i>
                        {checkStatus !== 'FL' ? 'Marcar Avería' : 'Reparar Avería'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </CSSTransition>
      )
    }

    if (currentView === 'faultView') {
      return (
        <CSSTransition key="faultView" timeout={300} classNames="fade">
          <div className="lm-body view-container slide-in">
            <div className="lm-subview">
              <div className="lm-card">
                <div className="lm-card-header">
                  <i className="fas fa-exclamation-triangle"></i> Marcar avería en taquilla
                </div>
                <div className="lm-card-body">
                  <RemoteActionFaultAddForm lockerType={this.state.lockerType} lockerSN={this.state.matrixSN} machine={this.props.machine} lockerMatricula={this.state.matrixMatricula} closeMatrixDialog={this.closeMatrixDialog} refreshMatrixData={refreshMatrix} />
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      );
    }

    if (currentView === 'repairFaultView') {
      return (
        <CSSTransition key="repairFaultView" timeout={300} classNames="fade">
          <div className="lm-body view-container slide-in">
            <div className="lm-subview">
              <div className="lm-card">
                <div className="lm-card-header">
                  <i className="fas fa-tools"></i> Marcar reparación de avería en taquilla
                </div>
                <div className="lm-card-body">
                  <RemoteActionFaultRepairForm lockerType={this.state.lockerType} lockerSN={this.state.matrixSN} machine={this.props.machine} lockerMatricula={this.state.matrixMatricula} closeMatrixDialog={this.closeMatrixDialog} refreshMatrixData={refreshMatrix} />
                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      );
    }
  }

  render() {

    const matrixRender = [];
    let lockerStatus = "";
    let matrixIndex = 0;
    let checkKiosc = 0;

    let columnHeight = 0;
    let matrixWidth = 0;
    // Columna visual de cada taquilla: alimenta el retardo escalonado de la
    // onda luminosa (--wave-delay) que barre la maquina de izq. a dcha.
    let waveColumn = 0;

    {
      this.props.matrixs.map(matrix => {
        {
          (matrix.Serial === this.props.machine.Serial) && matrix.Locker.map((lock, index) => {

            if (matrixIndex < this.props.machine.LastIndex) {

              let lockerSelected = lock.Mode + lock.Wide + lock.Type

              lock.Configured ? lockerStatus = lock.Status : lockerStatus = "Null"

              switch (lock.Type) {

                case "S":
                  columnHeight += 45
                  break;
                case "M":
                  columnHeight += 90
                  break;
                case "L":
                  columnHeight += 135
                  break;
                case "XL":
                  columnHeight += 180
                  break;
                case "2XL":
                  columnHeight += 225
                  break;
                case "3XL":
                  columnHeight += 270
                  break;

              }

              // La taquilla que completa la columna pertenece a la columna
              // actual: capturar antes de incrementar en el wrap.
              const cellColumn = waveColumn;

              if (columnHeight >= 270) {

                columnHeight = 0;
                waveColumn++;

                if (lock.Wide === 'N') {
                  matrixWidth += 45;
                } else {
                  matrixWidth += 60;
                }
              }

              matrixRender.push(

                /* Prefijo en la key: los kioskos se numeran con matrixIndex, que va un paso
                   por delante de index, asi que sin prefijo el kiosko empujado tras la
                   taquilla 10 (key 11) chocaba con la taquilla de index 11. */
                <div key={`locker-${index}`} id={`locker${lockerSelected}`} style={{ "--wave-delay": `${cellColumn * 0.1}s` }} onClick={e => this.openMatrixDialog(index + 1, lock.BLEName, lockerSelected, lock.BlockType, e)}>
                  <p>{this.props.getRoomNumber ? this.props.getRoomNumber(index) : index + this.props.machine.FirstIndex}</p>
                  <div id={lockerStatus}><p>{lockerStatus}</p></div>
                </div>
              );

              matrixIndex++

              if (lock.Position === "C" && checkKiosc === 0) {

                columnHeight += 135

                matrixRender.push(

                  <div key={`kiosk-${matrixIndex}`} id="lockerKioskLeft">
                  </div>

                );

                checkKiosc = 1
              } else if (lock.Position === "E" && checkKiosc === 0) {

                columnHeight += 90

                matrixRender.push(

                  <div key={`kiosk-${matrixIndex}`} id="lockerEcomKioskLeft">
                  </div>

                );

                checkKiosc = 1
              } else if (lock.Position === "C" && checkKiosc === 1) {

                columnHeight += 135

                matrixRender.push(

                  <div key={`kiosk-${matrixIndex}`} id="lockerKioskRight">
                  </div>

                );

                checkKiosc = 0
              } else if (lock.Position === "E" && checkKiosc === 1) {

                columnHeight += 90

                matrixRender.push(

                  <div key={`kiosk-${matrixIndex}`} id="lockerEcomKioskRight">
                  </div>

                );

                checkKiosc = 0
              }
            }
          })
        }
      })
    }

    return (
      <div id="matrixContainer" style={{ width: matrixWidth + 40 }}>
        <div className={`row wave-matrix${this.state.waveIntro ? ' wave-intro' : ''}`} id="lockerMatrix">
          {matrixRender}
        </div>
        <div>
          <Modal isOpen={this.state.matrixModalOpen} className="locker-modal-ble" toggle={this.closeMatrixDialog} size="xl">
            <ModalHeader toggle={this.closeMatrixDialog}>
              <span className="lm-modal-title">
                <i className="fas fa-door-open"></i> Taquilla {Number(this.state.matrixMatricula) + this.props.machine.FirstIndex - 1}
              </span>
            </ModalHeader>
            <ModalBody>
              {this.infoMatrix()}
            </ModalBody>
          </Modal>
        </div>
      </div>
    );

  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  blockOnlineSale: bindActionCreators(blockOnlineSale, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(MatrixConstructorAdmin)


